import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const AnnouncedEaster: FC<SvgIconProps> = ({ viewBox = '0 0 255 180', ...props }) => (
  <SvgIcon viewBox={viewBox} {...props} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      opacity=".1"
      d="M190.071 156.901c0 2.22-12.367 3.805-27.588 3.805-15.22 0-27.587-1.903-27.587-3.805 0-1.903 12.367-3.805 27.587-3.805 15.221 0 27.588 1.585 27.588 3.805Z"
      fill="#000"
    />
    <path
      d="M195.716 102.583c7.864 19.914-1.015 44.838-20.897 52.416-19.882 7.579-43.221-4.376-51.116-24.289-7.896-19.914-9.989-58.822 14.554-68.335 22.895-8.847 49.912 20.326 57.459 40.208Z"
      fill="url(#paint0_linear_6712_41133)"
    />
    <path
      d="M195.716 102.584c7.864 19.913-1.015 44.837-20.897 52.416-19.882 7.578-43.221-4.376-51.116-24.29-7.896-19.914-9.989-58.822 14.554-68.334 22.895-8.847 49.912 20.325 57.459 40.208Z"
      fill="url(#paint1_linear_6712_41133)"
    />
    <path
      d="M172.568 82.414a2.853 2.853 0 0 1-1.3 3.361 2.548 2.548 0 1 1-2.061-4.661 2.599 2.599 0 0 1 3.361 1.3ZM183.222 112.792a2.953 2.953 0 0 1-1.3 3.393 2.89 2.89 0 0 1-3.393-1.3 2.859 2.859 0 0 1 1.3-3.362 2.57 2.57 0 0 1 3.393 1.269ZM149.958 92.56a2.852 2.852 0 0 1-1.3 3.362 2.98 2.98 0 0 1-3.361-1.3 2.883 2.883 0 0 1 1.3-3.361 2.54 2.54 0 0 1 3.361 1.3ZM161.564 122.084a2.567 2.567 0 0 1-.454 2.82 2.563 2.563 0 0 1-2.78.657 2.569 2.569 0 1 1 3.234-3.477ZM140.731 129.567a2.54 2.54 0 0 1-.501 2.76 2.534 2.534 0 0 1-3.895-.285 2.536 2.536 0 0 1 1.003-3.775 2.555 2.555 0 0 1 1.965-.053 2.556 2.556 0 0 1 1.428 1.353ZM128.554 98.683a2.941 2.941 0 0 1-1.3 3.392 2.555 2.555 0 0 1-1.965.053 2.565 2.565 0 0 1-1.649-2.33 2.565 2.565 0 0 1 1.522-2.416 2.343 2.343 0 0 1 2.862.417c.24.252.421.553.53.883Z"
      fill="#F59DA7"
    />
    <path
      d="M140.097 72.457a96.442 96.442 0 0 1-17.092 4.852 46.455 46.455 0 0 0-2.537 6.945 112.575 112.575 0 0 0 21.912-5.835 131.019 131.019 0 0 0 23.021-11.891 46.37 46.37 0 0 0-6.754-3.393 116.537 116.537 0 0 1-18.55 9.322ZM118.756 108.862c.19 2.124.475 4.185.824 6.342a154.009 154.009 0 0 0 33.549-8.943 205.21 205.21 0 0 0 34.881-18.01 97.633 97.633 0 0 0-3.932-5.201 187.113 187.113 0 0 1-33.39 17.377 141.954 141.954 0 0 1-31.932 8.435ZM198.538 117.708a40.26 40.26 0 0 0-.635-7.293 188.737 188.737 0 0 1-36.815 19.597 142.72 142.72 0 0 1-33.041 8.752 41.122 41.122 0 0 0 4.566 5.612 152.172 152.172 0 0 0 30.727-8.403 212.16 212.16 0 0 0 35.198-18.265Z"
      fill="#75A5DE"
    />
    <path
      d="m173.835 72.647-10.686-1.078-6.691 12.684-14.047-3.17-6.881 11.415-12.208-5.36-4.503 5.391a59.539 59.539 0 0 0-.381 4.947l5.803-7.071 12.177 5.708 7.198-11.543 14.333 3.171 6.722-13.032 12.684 1.268c-1.11-1.205-2.315-2.283-3.52-3.33ZM193.432 97.477a72.564 72.564 0 0 0-1.839-3.393l-2.854 8.118-14.206-1.427-6.691 12.684-14.047-3.171-6.849 11.098-12.209-5.105-8.371 10.305-5.042-3.17c.412 1.49.825 2.917 1.3 4.28l4.313 2.791 8.72-10.591 12.525 5.422 6.881-11.415 14.365 3.171 6.722-13.001 14.555 1.141 2.727-7.737ZM186.614 129.725l-6.722 12.684-14.079-2.981-6.881 11.099-12.145-5.391-5.169 6.342c.825.507 1.681.951 2.537 1.395l3.551-4.185 12.684 5.39 6.913-11.732 14.365 3.171 6.722-13.001 7.515.729c.344-.871.64-1.761.888-2.664l-10.179-.856Z"
      fill="#FFFAEC"
    />
    <path
      opacity=".1"
      d="M127.539 164.195c0 2.219-12.366 3.805-27.587 3.805-15.22 0-27.587-1.903-27.587-3.805 0-1.903 12.366-3.805 27.587-3.805s27.587 1.585 27.587 3.805Z"
      fill="#000"
    />
    <path
      d="M141.809 119.102c0 23.149-18.709 44.711-41.857 44.711s-41.857-21.562-41.857-44.711C58.095 95.954 71.413 56 99.952 56c26.319.032 41.857 39.954 41.857 63.102Z"
      fill="url(#paint2_linear_6712_41133)"
    />
    <path
      d="M75.282 68.525c-.793.92-1.554 1.871-2.283 2.886a164.893 164.893 0 0 0 27.27 2.346c8.72-.026 17.428-.64 26.066-1.839a49.629 49.629 0 0 0-2.252-2.854 200.586 200.586 0 0 1-23.814 1.523c-8.37-.02-16.726-.71-24.987-2.062Z"
      fill="#FFC665"
    />
    <path
      d="M137.687 137.685a45.414 45.414 0 0 0 4.122-18.582v-1.617a204.499 204.499 0 0 1-42.586 4.788A150.181 150.181 0 0 1 58 116.345v2.758a45.189 45.189 0 0 0 3.837 17.98 170.64 170.64 0 0 0 37.386 4.217 216.839 216.839 0 0 0 38.464-3.615Z"
      fill="#DC5B29"
    />
    <path
      d="M76.645 155.823a38.049 38.049 0 0 0 46.708 0 195.674 195.674 0 0 1-24.987 1.681 150.856 150.856 0 0 1-21.721-1.681ZM61.171 135.307a46.787 46.787 0 0 0 2.95 6.342 165.35 165.35 0 0 0 35.514 3.963 210.497 210.497 0 0 0 35.737-3.171 47.717 47.717 0 0 0 3.171-6.12 209.194 209.194 0 0 1-39.32 3.71 159.463 159.463 0 0 1-38.052-4.724Z"
      fill="#FFC665"
    />
    <path
      d="M102.806 131.471a2.85 2.85 0 0 1-1.762 2.636 2.854 2.854 0 1 1 1.762-2.636ZM113.904 131.153a2.85 2.85 0 0 1-1.762 2.636 2.855 2.855 0 0 1-3.891-2.079 2.855 2.855 0 1 1 5.653-.557ZM124.59 129.884a2.852 2.852 0 0 1-4.872 2.018 2.856 2.856 0 0 1 2.018-4.872 3.365 3.365 0 0 1 2.854 2.854ZM134.103 128.966a2.856 2.856 0 0 1-1.761 2.636 2.856 2.856 0 0 1-3.11-.618 2.854 2.854 0 1 1 4.871-2.018ZM80.609 129.884a2.856 2.856 0 0 1-3.41 2.799 2.854 2.854 0 1 1 3.41-2.799ZM66.974 130.836a2.85 2.85 0 0 0 2.636-1.762 2.851 2.851 0 0 0-.618-3.11 2.854 2.854 0 1 0-2.018 4.872ZM91.39 131.153a2.852 2.852 0 0 1-3.41 2.799 2.854 2.854 0 0 1 .556-5.653 2.66 2.66 0 0 1 2.854 2.854ZM73.538 70.683a57.96 57.96 0 0 0-4.25 6.342 167.309 167.309 0 0 0 30.981 2.98 206.142 206.142 0 0 0 29.871-2.283 65.688 65.688 0 0 0-4.249-6.5 193.438 193.438 0 0 1-25.622 1.807 154.234 154.234 0 0 1-26.731-2.346Z"
      fill="#FFF7E4"
    />
    <path
      d="M63.676 89.358a81.247 81.247 0 0 0-1.712 5.137 164.07 164.07 0 0 0 38.305 4.63 212.006 212.006 0 0 0 37.576-3.488 80.034 80.034 0 0 0-1.807-5.296 206.121 206.121 0 0 1-36.086 3.393 158.134 158.134 0 0 1-36.276-4.376Z"
      fill="#FFC665"
    />
    <path
      d="M62.312 93.355a95.335 95.335 0 0 0-3.393 15.062 165.852 165.852 0 0 0 41.223 5.295 209.949 209.949 0 0 0 40.779-4.122 93.626 93.626 0 0 0-3.552-15.126 201.203 201.203 0 0 1-37.544 3.71 154.646 154.646 0 0 1-37.513-4.82Z"
      fill="#FFF7E4"
    />
    <path
      d="M102.806 106.418a2.85 2.85 0 0 1-1.762 2.636 2.854 2.854 0 1 1-1.092-5.49c.733.07 1.419.394 1.94.914.52.521.844 1.207.914 1.94ZM114.221 106.418a2.85 2.85 0 0 1-1.761 2.636 2.856 2.856 0 0 1-3.11-.618 2.848 2.848 0 0 1-.619-3.11 2.856 2.856 0 0 1 4.655-.926c.535.535.835 1.261.835 2.018ZM124.59 105.15a2.85 2.85 0 0 1-1.761 2.636 2.856 2.856 0 0 1-3.892-2.079 2.855 2.855 0 0 1 2.799-3.411c1.903.317 2.854 1.268 2.854 2.854ZM131.662 106.768a2.855 2.855 0 1 0 0-5.71 2.855 2.855 0 0 0 0 5.71ZM78.072 107.687a2.859 2.859 0 0 0 2.637-1.762 2.854 2.854 0 1 0-2.637 1.762ZM69.828 103.247a2.853 2.853 0 1 1-5.707.002 2.853 2.853 0 0 1 5.707-.002ZM91.708 106.418a2.852 2.852 0 0 1-3.41 2.799 2.854 2.854 0 1 1 3.41-2.799Z"
      fill="#FFA752"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6712_41133"
        x1="113.758"
        y1="85.803"
        x2="194.74"
        y2="121.097"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B89BCB" />
        <stop offset="1" stopColor="#9E78B8" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6712_41133"
        x1="113.758"
        y1="85.803"
        x2="194.74"
        y2="121.098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B89BCB" />
        <stop offset="1" stopColor="#9E78B8" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6712_41133"
        x1="65.579"
        y1="77.816"
        x2="133.754"
        y2="145.992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA752" />
        <stop offset="1" stopColor="#DC5B29" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
